import React from "react";

const Productname = ({ id }) => {
  return <>{id === "fgsa2142fa" ? <h2> Keyboard</h2> : <h2>HeadPhones</h2>}</>;
};

export default Productname;
